// import angular from 'angular';

/* eslint-disable */
export default function CustomTestingProcedure(
  $filter,
  $q,
  $scope,
  bcpDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  editCustomTestingProceduresDialog
) {
  const vm = this;

  vm.canExpand = false;
  vm.isExpanded = false;
  vm.hasData = false;

  vm.handleEditCustomTestingProcedures = _handleEditCustomTestingProcedures;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    _initEventListeners();
    _initPermissions();
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('bcp').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _initEventListeners() {
    // $scope.$on(
    //   'refreshBCPTeamAndContactSettings',
    //   _refreshTeamContactSetting
    // );
  }

  function _handleEditCustomTestingProcedures($event) {
    _loadCustomTestingProcedures().then(() => _openEditCustomTestingProceduresDialog($event, {
      assessmentId: vm.assessmentId,
      procedures: vm.procedures,
    }));
  }

  /** *********************************************
   * Private Functions
   */
  function _loadCustomTestingProcedures() {
    loaderService.showViewLoader = true;
    return bcpDataService.getCustomTestProcedures(vm.assessmentId)
      .then((response) => {
        vm.procedures = response.data;
        vm.hasData = true;
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _openEditCustomTestingProceduresDialog($event, locals) {
    ssDialogService.dialogs.bcp.editCustomTestingProceduresDialog = ssDialogService.alert(
      editCustomTestingProceduresDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.bcp.editCustomTestingProceduresDialog);
  }
}

CustomTestingProcedure.$inject = [
  '$filter',
  '$q',
  '$scope',
  'bcpDataService',
  'loaderService',
  'orgDataService',
  'ssDialogService',
  'userService',
  'editCustomTestingProceduresDialog'
];
